import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { movieCategories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-accent-500 text-2xl"><i className="ri-movie-2-fill"></i></span>
            <span className={`font-heading text-xl font-semibold ${isScrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}>
              被窝影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/'
                  ? 'bg-primary-500 text-white'
                  : isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            {movieCategories.filter(c => c.slug !== 'all').slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-500 text-white'
                    : isScrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500 text-white'
                  : isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <div className={`relative hidden md:block ${isScrolled || !isHome ? 'text-foreground-600' : 'text-white/70'}`}>
              <input
                type="text"
                placeholder="搜索电影..."
                className={`pl-9 pr-4 py-2 rounded-full text-sm border outline-none transition-colors w-48 focus:w-64 ${
                  isScrolled || !isHome
                    ? 'bg-background-100 border-background-200 focus:border-primary-400 text-foreground-800'
                    : 'bg-white/10 border-white/20 focus:border-white/40 text-white placeholder-white/50'
                }`}
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm"></i>
            </div>
            <button
              className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg cursor-pointer"
              onClick={() => setIsMobileOpen(!isMobileOpen)}
            >
              <i className={`ri-${isMobileOpen ? 'close' : 'menu'}-line text-xl ${isScrolled || !isHome ? 'text-foreground-800' : 'text-white'}`}></i>
            </button>
          </div>
        </div>

        {isMobileOpen && (
          <div className="md:hidden border-t border-background-200/60 pb-4 pt-2 bg-background-50">
            <Link to="/" className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap cursor-pointer">首页</Link>
            {movieCategories.filter(c => c.slug !== 'all').map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 whitespace-nowrap cursor-pointer">关于我们</Link>
          </div>
        )}
      </div>
    </nav>
  );
}